export const setupAjaxForms = () => {
  const $form = $('.js-submission-form--ajax')

  if (!$form.length) {
    return
  }

  $form.each((_, el) => {
    const $submissionForm = $(el)

    if ($submissionForm[0].classList.contains('checkout-form')) {
        return false;
    }

    $submissionForm.on('submit', (e) => {
      e.preventDefault()

      $.ajax({
        type: 'post',
        dataType: 'json',
        data: new FormData(el),
        processData: false,
        contentType: false,
        url: $submissionForm.prop('action'),
        beforeSend: () => {
          $submissionForm.find('.form-error-message').hide()
        },
        success: (resp) => {
            $submissionForm.replaceWith(`<div class="form-success-message form-success-heading">${resp.data.message}</div>`)

            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'form_submission',
                    form_type: $submissionForm.attr('id'),
                })
            }
        },
        error: () => {
          $submissionForm.find('.form-error-message').show()
        },
        complete: () => {
          $submissionForm.find('button[type=submit]').prop('disabled', false)
        }
      })
    })
  })
}

$(document).ready(function() {
  setupAjaxForms()
});
